'use strict'
import { request } from '../../plugins/http'

export default async (userCompanyId) => {
    return await request.delete('/empresa_usuario', {params:{id:userCompanyId}})
}